import { fetchV3WithTranslateServerErrors } from './base';
import { _getSponsorshipAssetsUrl } from './constants';
import { EVENT_DEFAULT_ERROR_MESSAGE } from '../constants';

const ERROR_SPEC = {
    default: () => EVENT_DEFAULT_ERROR_MESSAGE,
};

export const getSponsorshipAssets = (eventId, params) =>
    fetchV3WithTranslateServerErrors(
        ERROR_SPEC,
        _getSponsorshipAssetsUrl(eventId, params),
    );
